(()=>{
  if(location.pathname.replace(/\/$/,'')!='/products/fan-zip-hoodie-selbst-gestalten')return;
  if(window.__MF_ZIP_PULLI_PRICING_V1__)return;
  window.__MF_ZIP_PULLI_PRICING_V1__=true;

  const IMAGE_FEE_VARIANT=53870952743259;
  const TEXT_FEE_VARIANT=54099458064731;
  const IMAGE_EXTRA_CENTS=400;
  const TEXT_CENTS=200;
  const root=document.querySelector('[data-mfz]');
  if(!root)return;

  const counts={front:{image:0,text:0},back:{image:0,text:0}};
  let productPromise=null;
  let renderQueued=false;

  const money=cents=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
  const currentSide=()=>root.querySelector('[data-side].on')?.dataset.side||'front';
  const normalizeId=value=>String(value||'').split('/').pop();

  function readCurrentLayers(){
    const side=currentSide();
    let image=0,text=0;
    root.querySelectorAll('[data-layers] .mfz-layer').forEach(layer=>{
      const icon=layer.querySelector('i')?.textContent?.trim()||'';
      if(icon==='T')text+=1;
      else if(icon==='▧')image+=1;
    });
    counts[side]={image,text};
  }

  function feeState(){
    const imageCount=counts.front.image+counts.back.image;
    const textCount=counts.front.text+counts.back.text;
    const imageExtras=Math.max(0,imageCount-1);
    const extraCents=imageExtras*IMAGE_EXTRA_CENTS+textCount*TEXT_CENTS;
    return{imageCount,textCount,imageExtras,extraCents};
  }

  function ensurePriceBox(){
    let box=root.querySelector('[data-mfj-pricebox]');
    if(box)return box;
    const status=root.querySelector('[data-status]');
    if(!status?.parentElement)return null;
    box=document.createElement('div');
    box.className='mfh-info';
    box.dataset.mfjPricebox='1';
    box.innerHTML='<span>Grundpreis</span><b data-mfj-price-base>–</b><span>Zusatzoptionen</span><b data-mfj-price-extra>+ 0,00 €</b><span>Gesamtpreis</span><b data-mfj-price-total>–</b>';
    status.parentElement.insertBefore(box,status);
    return box;
  }

  async function loadProduct(){
    if(productPromise)return productPromise;
    productPromise=fetch('/products/fan-zip-hoodie-selbst-gestalten.js',{headers:{Accept:'application/json'},cache:'no-store'})
      .then(r=>{if(!r.ok)throw new Error('Produktpreis konnte nicht geladen werden');return r.json()})
      .catch(error=>{console.error('[MF Zipp Pulli Preis]',error);return null});
    return productPromise;
  }

  function selectedOrderLines(){
    try{return window.__MF_ZIP_PULLI_ORDER_QTY__?.getSelected?.()||[]}catch(_){return[]}
  }

  async function baseCents(){
    const product=await loadProduct();
    const variants=Array.isArray(product?.variants)?product.variants:[];
    if(!variants.length)return 0;
    const byId=new Map(variants.map(v=>[normalizeId(v.id),Number(v.price)||0]));
    const selected=selectedOrderLines();
    if(selected.length){
      return selected.reduce((sum,line)=>sum+(byId.get(normalizeId(line.id))||0)*Math.max(0,Number(line.quantity)||0),0);
    }
    const currentId=normalizeId(document.querySelector('form[action*="/cart/add"] [name="id"]')?.value||root.dataset.variant||'');
    const current=variants.find(v=>normalizeId(v.id)===currentId)||variants[0];
    return Number(current?.price)||0;
  }

  async function renderPrice(){
    renderQueued=false;
    const box=ensurePriceBox();
    if(!box)return;
    const base=await baseCents();
    const fees=feeState();
    const baseNode=box.querySelector('[data-mfj-price-base]');
    const extraNode=box.querySelector('[data-mfj-price-extra]');
    const totalNode=box.querySelector('[data-mfj-price-total]');
    if(baseNode)baseNode.textContent=base?money(base):'–';
    if(extraNode)extraNode.textContent='+ '+money(fees.extraCents);
    if(totalNode)totalNode.textContent=base?money(base+fees.extraCents):'–';
  }

  function queueRender(){
    if(renderQueued)return;
    renderQueued=true;
    requestAnimationFrame(renderPrice);
  }

  function syncCurrentSide(){
    readCurrentLayers();
    queueRender();
  }

  function installObservers(){
    const layers=root.querySelector('[data-layers]');
    if(layers)new MutationObserver(syncCurrentSide).observe(layers,{childList:true,subtree:true,characterData:true});

    root.querySelectorAll('[data-side]').forEach(button=>button.addEventListener('click',()=>setTimeout(syncCurrentSide,0)));

    root.querySelector('[data-copy-side]')?.addEventListener('click',()=>{
      const from=currentSide(),to=from==='front'?'back':'front';
      setTimeout(()=>{
        counts[to]={...counts[from]};
        queueRender();
      },0);
    });

    root.addEventListener('input',event=>{
      if(event.target?.matches?.('[data-mfj-order-input]'))queueRender();
    },true);
    root.addEventListener('change',event=>{
      if(event.target?.matches?.('[data-mfj-order-input]'))queueRender();
    },true);
  }

  function cartDescription(fees){
    return `${fees.imageCount} Bilder/Logos · 1 Bild inklusive · ${fees.imageExtras} weitere × 4,00 € · ${fees.textCount} Texte × 2,00 €`;
  }

  function installCartHook(){
    if(window.__MF_ZIP_PULLI_PRICING_FETCH_V1__)return true;
    if(!window.__MF_ZIP_PULLI_ORDER_QTY__?.getSelected)return false;
    window.__MF_ZIP_PULLI_PRICING_FETCH_V1__=true;
    const previousFetch=window.fetch.bind(window);
    window.fetch=async function(input,init={}){
      const url=typeof input==='string'?input:String(input?.url||'');
      const fd=init?.body;
      if(!url.includes('/cart/add.js')||!(fd instanceof FormData)||String(fd.get('properties[_MF Designer]')||'')!=='Fan Zipp Pulli Designer v2'){
        return previousFetch(input,init);
      }

      readCurrentLayers();
      const fees=feeState();
      const group=`mfj-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,8)}`;
      try{
        fd.set('properties[Preisberechnung]',cartDescription(fees));
        fd.set('properties[_MF Zipp Pulli Bild-Aufpreis Anzahl]',String(fees.imageExtras));
        fd.set('properties[_MF Zipp Pulli Text-Aufpreis Anzahl]',String(fees.textCount));
        fd.set('properties[_MF Zipp Pulli Aufpreis Cent]',String(fees.extraCents));
        fd.set('properties[_MF Zipp Pulli Gruppe]',group);
      }catch(_){}

      const productResponse=await previousFetch(input,init);
      if(!productResponse?.ok||fees.extraCents<1)return productResponse;

      const items=[];
      if(fees.imageExtras>0){
        items.push({
          id:IMAGE_FEE_VARIANT,
          quantity:fees.imageExtras,
          properties:{
            '_MF Designer Aufpreis':'Fan Zipp Pulli Designer v2',
            '_MF Zugehöriger Artikel':'Fan Jogginghose',
            '_MF Zipp Pulli Gruppe':group,
            'Aufpreis':'weiteres Bild/Logo'
          }
        });
      }
      if(fees.textCount>0){
        items.push({
          id:TEXT_FEE_VARIANT,
          quantity:fees.textCount,
          properties:{
            '_MF Designer Aufpreis':'Fan Zipp Pulli Designer v2',
            '_MF Zugehöriger Artikel':'Fan Jogginghose',
            '_MF Zipp Pulli Gruppe':group,
            'Aufpreis':'Text'
          }
        });
      }

      const feeResponse=await previousFetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items})
      });
      return feeResponse?.ok?productResponse:feeResponse;
    };
    return true;
  }

  window.__MF_ZIP_PULLI_PRICING__={
    getCounts:()=>JSON.parse(JSON.stringify(counts)),
    getFees:()=>({...feeState()}),
    refresh:()=>{syncCurrentSide();queueRender()}
  };

  installObservers();
  syncCurrentSide();
  loadProduct().then(queueRender);

  let tries=0;
  const hookTimer=setInterval(()=>{
    tries+=1;
    if(installCartHook()||tries>=200)clearInterval(hookTimer);
  },50);
})();